// extracted by mini-css-extract-plugin
export var addButton = "_fa-0";
export var border = "_fa-8";
export var check = "_fa-h";
export var danger = "_fa-6";
export var dropdownContainer = "_fa-1";
export var editModalBody = "_fa-j";
export var footerContainer = "_fa-i";
export var fullWidth = "_fa-a";
export var hide = "_fa-9";
export var icon = "_fa-3";
export var input = "_fa-7";
export var inputFlex = "_fa-b";
export var inputWrapper = "_fa-c";
export var manualFocus = "_fa-5";
export var optionButton = "_fa-4";
export var pillWrapper = "_fa-e";
export var pointer = "_fa-2";
export var showOverflow = "_fa-f";
export var tagsFlex = "_fa-d";
export var xButton = "_fa-g";